var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumRating({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 203,
    viewBox: "0 0 284 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8731 27.3457H36.5827C34.3033 27.3457 32.1321 28.318 30.6143 30.0185L14.0316 48.5972C12.7232 50.0631 12 51.9594 12 53.9243V123.6V192.346H207.121H233.416C235.696 192.346 237.868 191.373 239.386 189.672L255.969 171.085C257.277 169.619 258 167.723 258 165.759V96.091V27.3457H62.8731Z",
    fill: "#FFCD00",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267 128.346V165.181C267 170.131 265.252 174.922 262.063 178.708L249.293 193.873C245.303 198.611 239.425 201.346 233.23 201.346H205",
    stroke: "black",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 74.3457L2 54.1249C2 49.238 3.70438 44.504 6.81951 40.7387L20.7011 23.9594C24.6906 19.1372 30.623 16.3457 36.8816 16.3457L74 16.3457",
    stroke: "black",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.467 23.1002C240.467 23.1002 234.467 23.1002 230.467 23.1002L227.55 2.69149C233.049 2.69149 236.051 2.69068 242.05 2.69144L244.467 23.1002ZM262.761 34.8906C262.761 24.1914 258.05 23.1002 248.55 23.1002L246.55 2.69146C266.05 2.01084 281.467 4.89074 280.467 38.8901L262.761 34.8906ZM262.761 52.3908C262.95 48.6122 262.763 43.3905 262.761 39.8905L280.467 43.8905C280.467 49.8131 280.467 51.8908 280.467 57.3908L262.761 52.3908Z",
    fill: "url(#paint0_linear_18_15)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.154 23.1002C222.155 23.1002 215.034 23.1002 211.034 23.1002L207.55 2.69137C213.049 2.69137 217.051 2.6906 223.05 2.69137L226.154 23.1002Z",
    fill: "url(#paint1_linear_18_15)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_15",
    x1: 224.5,
    y1: 0.00000160568,
    x2: 283.55,
    y2: 75.6915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_15",
    x1: 224.5,
    y1: 0.00000160568,
    x2: 283.55,
    y2: 75.6915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumRating);
export default __webpack_public_path__ + "static/media/medium-rating.603d9ec59d1366b285fcb7b8ac52fedb.svg";
export { ForwardRef as ReactComponent };